import { X } from 'lucide-react';
import iconLogo from '../assets/logo/icon-logo.svg';

interface LogoutPopupProps {
  isOpen: boolean;
  closePopup: () => void;
  handleLogout: () => void;
}

export function LogoutPopup({ isOpen, closePopup, handleLogout }: LogoutPopupProps) {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center
                 bg-gradient-to-br dark:from-[#111111] dark:via-[#1A1A1A] dark:to-[#2A2A2A]
                 from-grey-300 via-grey-200 to-grey-50
                 bg-opacity-80 backdrop-blur-sm"
    >
      <div
        className="relative w-full max-w-sm sm:max-w-md
                   dark:bg-white/10 border border-white/20
                   backdrop-blur-md rounded-2xl shadow-xl
                   px-12 py-14 text-white bg-white"
      >
        <button
          type="button"
          className="absolute top-4 right-4 dark:text-gray-200 hover:text-gray-50 text-grey-800
                     transition-colors duration-200 focus:outline-none"
          onClick={closePopup}
          aria-label="Close"
        >
          <X size={20} />
        </button>

        <img
          src={iconLogo}
          alt=""
          className="mx-auto mb-6 w-16 h-auto"
        />

        <h2 className="mb-2 text-2xl font-bold dark:text-white text-gray-800">
          Are you sure you want to log out?
        </h2>

        <p className="mb-8 text-sm text-gray-800 dark:text-gray-400">
          Please confirm if you want to log out.
        </p>

        <div className="flex flex-col sm:flex-row gap-3">
          <button
            type="button"
            className="flex-1 px-4 py-2 rounded-lg border border-gray-400/40
                       bg-transparent text-gray-800 dark:text-gray-400
                       hover:bg-white/10 active:scale-95
                       focus:outline-none focus:ring-2 focus:ring-gray-400/50
                       transition-all duration-200"
            onClick={closePopup}
          >
            Cancel
          </button>

          <button
            type="button"
            className="flex-1 px-4 py-2 rounded-lg
                       bg-[#ffc928] text-white font-semibold
                       hover:bg-signalOrange-700 active:scale-95
                       focus:outline-none focus:ring-2 focus:ring-signalOrange-500/50
                       transition-all duration-200"
            onClick={handleLogout}
          >
            Log Out
          </button>
        </div>
      </div>
    </div>
  );
}
